module.exports = __webpack_public_path__ + "static/media/ld-y.3b0c4ce5.jpg";